import * as D from '../../def';
export const annotationEth:D.IAnnotation = {
  circle: {
    pricePoints: [
      {
        color: 'red',
        date: {
          year: 2016,
          month: 3,
          day: 14,
        },
      },
      {
        color: 'red',
        date: {
          year: 2016,
          month: 6,
          day: 17,
        },
      },
      {
        color: 'green',
        date: {
          year: 2016,
          month: 12,
          day: 28,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 3,
          day: 30,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 4,
          day: 9,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 6,
          day: 17,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 9,
          day: 2,
        },
      },
      {
        color: 'red',
        date: {
          year: 2018,
          month: 1,
          day: 14,
        },
      },
      {
        color: 'green',
        date: {
          year: 2018,
          month: 12,
          day: 18,
        },
      },
      {
        color: 'green',
        date: {
          year: 2020,
          month: 3,
          day: 19,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 5,
          day: 12,
        },
      },
    ],
    IndicePoints: [
      {
        color: 'red',
        date: {
          year: 2016,
          month: 3,
          day: 14,
        },
      },
      {
        color: 'red',
        date: {
          year: 2016,
          month: 6,
          day: 17,
        },
      },
      {
        color: 'green',
        date: {
          year: 2016,
          month: 12,
          day: 28,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 3,
          day: 30,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 4,
          day: 9,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 6,
          day: 17,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 9,
          day: 2,
        },
      },
      {
        color: 'red',
        date: {
          year: 2018,
          month: 1,
          day: 14,
        },
      },
      {
        color: 'green',
        date: {
          year: 2018,
          month: 12,
          day: 18,
        },
      },
      {
        color: 'green',
        date: {
          year: 2020,
          month: 3,
          day: 19,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 5,
          day: 12,
        },
      },
    ],
  },
};
